function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import LogoText, { LogoSizes } from '@/components/LogoText';
import { faTwitch, faYoutube } from '@fortawesome/free-brands-svg-icons';
import TrovoIcon from '@/components/icons/logos/Trovo';
import { AuthProviders } from '@/types/server';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import { openProviderAuthentication } from '@/actions/AuthActions';
import { useNavigate, useSearchParams } from 'react-router';
import { SearchParams, WebRoutes } from '@/utils/constants';
import { faSignIn } from '@fortawesome/free-solid-svg-icons';
import useAppStore from '@/stores/NativeStore';
import { sanitizePathname } from '@/utils/url';
import useIsNative from '@/hooks/useIsNative';
import NoiceIcon from '@/components/icons/logos/Noice';
import SoopIcon from '../icons/logos/Soop';
import { FormattedMessage, useIntl } from 'react-intl';
import loginArtBlue from '../../assets/loginArtBlue.jpg';
import loginArtRed from '../../assets/loginArtRed.jpg';
import loginArtGreen from '../../assets/loginArtGreen.jpg';
import { Helmet } from 'react-helmet';
import useHydrated from '@/hooks/useHydrated';
import { useShallow } from 'zustand/react/shallow';
import { Anchor, Button, Divider, Image, Text } from '@mantine/core';
import Icon, { IconSizes } from '../Icon';
import styles from './Login.module.scss';
import ErrorNotice from '../ErrorNotice';
import classNames from 'classnames';
function SSOLoginButton(props) {
    return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
        size: "sm",
        leftSection: /*#__PURE__*/ _jsx(Icon, {
            size: IconSizes.SM,
            icon: faSignIn
        })
    }, props), {
        children: /*#__PURE__*/ _jsx(FormattedMessage, {
            id: "SnUysG",
            defaultMessage: "Login with Browser"
        })
    }));
}
function TwitchLoginButton(props) {
    return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
        size: "sm",
        leftSection: /*#__PURE__*/ _jsx(Icon, {
            size: IconSizes.SM,
            icon: faTwitch
        })
    }, props), {
        children: "Twitch"
    }));
}
function YoutubeLoginButton(props) {
    return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
        size: "sm",
        leftSection: /*#__PURE__*/ _jsx(Icon, {
            size: IconSizes.SM,
            icon: faYoutube
        })
    }, props), {
        children: "Youtube"
    }));
}
function TrovoLoginButton(props) {
    return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
        size: "sm",
        leftSection: /*#__PURE__*/ _jsx(TrovoIcon, {})
    }, props), {
        children: "Trovo"
    }));
}
function NoiceLoginButton(props) {
    return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
        size: "sm",
        leftSection: /*#__PURE__*/ _jsx(NoiceIcon, {})
    }, props), {
        children: "Noice"
    }));
}
function SoopLoginButton(props) {
    return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
        size: "sm",
        leftSection: /*#__PURE__*/ _jsx(SoopIcon, {})
    }, props), {
        children: "SOOP"
    }));
}
var _obj;
var LoginButtonByProvider = (_obj = {}, _define_property(_obj, AuthProviders.TWITCH, TwitchLoginButton), _define_property(_obj, AuthProviders.YOUTUBE, YoutubeLoginButton), _define_property(_obj, AuthProviders.TROVO, TrovoLoginButton), _define_property(_obj, AuthProviders.NOICE, NoiceLoginButton), _define_property(_obj, AuthProviders.SOOP, SoopLoginButton), _obj);
function LoginButtons(param) {
    var loadingButtonProvider = param.loadingButtonProvider, handleOpenProviderAuthentication = param.handleOpenProviderAuthentication;
    var intl = useIntl();
    var provider = useAuthenticationStore(function(state) {
        return state.provider;
    });
    var negotiated = useAppStore(function(state) {
        return state.negotiated;
    });
    var isNative = useIsNative();
    if (negotiated || isNative) {
        return /*#__PURE__*/ _jsx(SSOLoginButton, {
            onClick: function() {
                return handleOpenProviderAuthentication('sso');
            },
            loading: loadingButtonProvider === 'sso'
        });
    }
    var MainButton = LoginButtonByProvider[provider];
    if (provider == null || MainButton == null) {
        return /*#__PURE__*/ _jsxs(React.Fragment, {
            children: [
                /*#__PURE__*/ _jsx(TwitchLoginButton, {
                    loading: loadingButtonProvider === AuthProviders.TWITCH,
                    onClick: function() {
                        return handleOpenProviderAuthentication(AuthProviders.TWITCH);
                    }
                }),
                /*#__PURE__*/ _jsx(YoutubeLoginButton, {
                    loading: loadingButtonProvider === AuthProviders.YOUTUBE,
                    onClick: function() {
                        return handleOpenProviderAuthentication(AuthProviders.YOUTUBE);
                    }
                }),
                /*#__PURE__*/ _jsx(TrovoLoginButton, {
                    loading: loadingButtonProvider === AuthProviders.TROVO,
                    onClick: function() {
                        return handleOpenProviderAuthentication(AuthProviders.TROVO);
                    }
                }),
                /*#__PURE__*/ _jsx(NoiceLoginButton, {
                    loading: loadingButtonProvider === AuthProviders.NOICE,
                    onClick: function() {
                        return handleOpenProviderAuthentication(AuthProviders.NOICE);
                    }
                }),
                /*#__PURE__*/ _jsx(SoopLoginButton, {
                    loading: loadingButtonProvider === AuthProviders.SOOP,
                    onClick: function() {
                        return handleOpenProviderAuthentication(AuthProviders.SOOP);
                    }
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MainButton, {
                variant: "inverse",
                onClick: function() {
                    return handleOpenProviderAuthentication(provider);
                },
                loading: loadingButtonProvider === provider
            }),
            /*#__PURE__*/ _jsx(Divider, {
                label: intl.formatMessage({
                    id: "INlWvJ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "OR"
                        }
                    ]
                })
            }),
            provider !== AuthProviders.TWITCH ? /*#__PURE__*/ _jsx(TwitchLoginButton, {
                loading: loadingButtonProvider === AuthProviders.TWITCH,
                onClick: function() {
                    return handleOpenProviderAuthentication(AuthProviders.TWITCH);
                }
            }) : null,
            provider !== AuthProviders.YOUTUBE ? /*#__PURE__*/ _jsx(YoutubeLoginButton, {
                loading: loadingButtonProvider === AuthProviders.YOUTUBE,
                onClick: function() {
                    return handleOpenProviderAuthentication(AuthProviders.YOUTUBE);
                }
            }) : null,
            provider !== AuthProviders.TROVO ? /*#__PURE__*/ _jsx(TrovoLoginButton, {
                loading: loadingButtonProvider === AuthProviders.TROVO,
                onClick: function() {
                    return handleOpenProviderAuthentication(AuthProviders.TROVO);
                }
            }) : null,
            provider !== AuthProviders.NOICE ? /*#__PURE__*/ _jsx(NoiceLoginButton, {
                loading: loadingButtonProvider === AuthProviders.NOICE,
                onClick: function() {
                    return handleOpenProviderAuthentication(AuthProviders.NOICE);
                }
            }) : null,
            provider !== AuthProviders.SOOP ? /*#__PURE__*/ _jsx(SoopLoginButton, {
                loading: loadingButtonProvider === AuthProviders.SOOP,
                onClick: function() {
                    return handleOpenProviderAuthentication(AuthProviders.SOOP);
                }
            }) : null
        ]
    });
}
function LoginPanel(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    var _useAuthenticationStore = useAuthenticationStore(useShallow(function(state) {
        return {
            setUnverified2FA: state.setUnverified2FA,
            setRedirectPath: state.setRedirectPath
        };
    })), setUnverified2FA = _useAuthenticationStore.setUnverified2FA, setRedirectPath = _useAuthenticationStore.setRedirectPath;
    var _React_useState = _sliced_to_array(React.useState(null), 2), error = _React_useState[0], setError = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), loadingButtonProvider = _React_useState1[0], setLoadingButtonProvider = _React_useState1[1];
    var _useSearchParams = _sliced_to_array(useSearchParams(), 1), searchParams = _useSearchParams[0];
    var navigate = useNavigate();
    var handleOpenProviderAuthentication = React.useCallback(function(provider) {
        try {
            var returnTo = searchParams.get(SearchParams.RETURN_TO);
            if (returnTo != null) {
                setRedirectPath(sanitizePathname(returnTo));
            } else {
                setRedirectPath(null);
            }
            setUnverified2FA(false);
            setLoadingButtonProvider(provider);
            openProviderAuthentication(provider);
            if (provider === 'sso') {
                navigate(WebRoutes.LOGIN_SSO);
            }
        } catch (error) {
            if (_instanceof(error, Error)) {
                setError(error.message);
            } else {
                setError('An unknown error occurred.');
            }
            setLoadingButtonProvider(null);
        }
    }, [
        searchParams,
        setUnverified2FA,
        setRedirectPath,
        navigate
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: classNames(styles.loginPanel, className)
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(LogoText, {
                size: LogoSizes.MEDIUM
            }),
            /*#__PURE__*/ _jsx(Text, {
                size: "sm",
                className: styles.loginPanelText,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "nXRDFp",
                    defaultMessage: "Select a provider to sign in with"
                })
            }),
            /*#__PURE__*/ _jsx(LoginButtons, {
                handleOpenProviderAuthentication: handleOpenProviderAuthentication,
                loadingButtonProvider: loadingButtonProvider
            }),
            /*#__PURE__*/ _jsx(Text, {
                size: "sm",
                className: styles.loginPanelText,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "Q20WZt",
                    defaultMessage: "By signing in, you agree to our <link>Terms of Service</link>.",
                    values: {
                        link: function(text) {
                            return /*#__PURE__*/ _jsx(Anchor, {
                                href: WebRoutes.TERMS,
                                children: text
                            });
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(ErrorNotice, {
                children: error
            })
        ]
    }));
}
export default function Login() {
    var loginArt = React.useMemo(function() {
        return [
            loginArtBlue,
            loginArtRed,
            loginArtGreen
        ][Math.floor(Math.random() * 3)];
    }, []);
    var intl = useIntl();
    var _useAuthenticationStore = useAuthenticationStore(useShallow(function(state) {
        return {
            isLoggedIn: state.isLoggedIn,
            accessToken: state.accessToken
        };
    })), isLoggedIn = _useAuthenticationStore.isLoggedIn, accessToken = _useAuthenticationStore.accessToken;
    var isHydrated = useHydrated(useAuthenticationStore);
    var _useSearchParams = _sliced_to_array(useSearchParams(), 1), searchParams = _useSearchParams[0];
    var navigate = useNavigate();
    React.useEffect(function() {
        if (!isLoggedIn) {
            return;
        }
        var returnTo = searchParams.get(SearchParams.RETURN_TO);
        var _sanitizePathname;
        navigate((_sanitizePathname = sanitizePathname(returnTo)) !== null && _sanitizePathname !== void 0 ? _sanitizePathname : WebRoutes.DASHBOARD);
    }, [
        isLoggedIn,
        navigate,
        searchParams
    ]);
    if (!isHydrated || accessToken != null || isLoggedIn) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "AyGauy",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Login"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.loginPage,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.loginPanelContainer,
                        children: /*#__PURE__*/ _jsx(LoginPanel, {
                            className: styles.panel
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.loginArtContainer,
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: loginArt,
                            className: styles.loginArt
                        })
                    })
                ]
            })
        ]
    });
}
